<script>
  import { Button, Row, Icon, Block } from 'bastone'
  import { colors } from '../consts'
  export let fill = false
  export let width = '5rem'
  export let minWidth = undefined
  export let height = '2rem'
  export let fontSize = '0.8rem'
  export let bold = false
  export let leftBorder = undefined
  export let rightBorder = undefined
  export let border = 2
  export let borderColor = colors.black
  export let color = undefined
  export let backgroundColor = undefined
  export let icon = undefined
  export let iconSize = undefined
  export let space = '0.4rem'

  $: realColor = color || (fill? colors.white : colors.black)
  $: realBgColor = backgroundColor || (fill ? colors.black : colors.transparent)

</script>

<Button 
  color={realColor} backgroundColor={realBgColor} activeBgColor={colors.lightGray}
  {width} {height} {fontSize} {minWidth} {bold}
  borderRadius=0 {border} {borderColor} {leftBorder} {rightBorder}
  on:click
>
  <Row align=center height=100%>
    {#if icon}
    <Icon name={icon} size={iconSize || fontSize} {bold}/>
    <Block width={space}/>
    {/if}
    <slot></slot>
    {#if icon}
    <Block width={space}/>
    {/if}
  </Row>

</Button>